import { useMemo } from "react"
import type { CombinedError } from "urql"
import { useQuery } from "urql"

import { FULL_LIST_LIMIT } from "@/constants/common"
import type { ComputedProductStatus, Product, Query } from "@/graphql/codegen/graphql"
import { ProductListShortInfoDocument } from "@/graphql/codegen/graphql"

interface UseProductsForAssociationListReturn {
  products: Product[]
  fetchingProducts: boolean
  error?: CombinedError
}

const useProductsForAssociationList = ({
  query,
  productIds,
  computedProductStatuses,
  pause,
}: {
  query?: string
  productIds?: number[]
  computedProductStatuses?: ComputedProductStatus[]
  pause?: boolean
}): UseProductsForAssociationListReturn => {
  const hasInputParams = productIds?.length || (query && query?.length >= 2)
  const [{ error, data, fetching }] = useQuery<Pick<Query, "product">>({
    query: ProductListShortInfoDocument,
    variables: {
      input: {
        filter: {
          query,
          productIds,
          ...(computedProductStatuses ? { computedProductStatuses } : {}),
        },
        offset: 0,
        limit: FULL_LIST_LIMIT,
      },
    },
    pause: pause || !hasInputParams,
  })

  const products = useMemo(() => {
    if (data?.product?.list?.__typename === "ProductListSuccess") {
      return data?.product?.list?.products
    }
    return []
  }, [data])

  return {
    products,
    fetchingProducts: fetching,
    error,
  }
}

export default useProductsForAssociationList
